OT.createNS('OT.Redesign.Views.TableCategories');

OT.Redesign.Views.TableCategories = function() {
  $('[data-table-categories]').on('click', function(event) {
    var $this = $(this);
    var tableCategories = $this.data('table-categories').split(',');
    var baseLink = $this.data('href');

    if (tableCategories.length === 1 && OTSearchData.Experiments.sv2134 === 1) {
      window.location.href = baseLink + '&tc=' + tableCategories[0];
      return;
    }

    function showHideOverlay() {
      var $overlay = $('#table-categories-overlay');
      $overlay.show();
      $overlay.on('click', function() {
        $overlay.hide();
      }).on('click', '.table-selector', function(e) {
        e.stopPropagation();
      });
    }

    function isDefaultAvail() {
      var $standardSlotButton = $('#table-categories-overlay .category-row[data-standard-category="true"] .right');
      var hasDefaultTableCategory = tableCategories.indexOf("default") !== -1;

      if (hasDefaultTableCategory) {
        $standardSlotButton.text($standardSlotButton.closest('.table-selector-content').data('select-translation'));
        $standardSlotButton.attr('href', baseLink + $standardSlotButton.data('href-addon'));
        $standardSlotButton.addClass('category-button button').removeClass('unavailable-text');
      } else {
        $standardSlotButton.text($standardSlotButton.closest('.table-selector-content').data('unavailable-translation'));
        $standardSlotButton.attr('href', '');
        $standardSlotButton.addClass('unavailable-text').removeClass('category-button button');
      }
    }

    function fillOtherCategories() {
      var selector = OTSearchData.Experiments.sv2134 ? '' : '[data-standard-category="false"]';
      $('#table-categories-overlay .category-row' + selector).each(function() {
        var $this = $(this);
        var $button = $this.find('.category-button');
        if (tableCategories.indexOf($this.data('category')) !== -1) {
          $button.attr('href', baseLink + $button.data('href-addon'));
          $this.show();
        } else {
          $this.css('display', 'none');
          $this.find('.category-button').removeAttr('href');
        }
      });
    }

    isDefaultAvail();
    fillOtherCategories();
    showHideOverlay();
  });
  $('[data-table-categories]:first').attr('id', 'clicky-tc-test-timeslot');
  //made to open modal for acceptance tests
};
